import { render, staticRenderFns } from "./BodyStageStepper.vue?vue&type=template&id=09cdc6b7&scoped=true&"
import script from "./BodyStageStepper.vue?vue&type=script&lang=js&"
export * from "./BodyStageStepper.vue?vue&type=script&lang=js&"
import style0 from "./BodyStageStepper.vue?vue&type=style&index=0&id=09cdc6b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cdc6b7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
